export const CAROUSELS_PER_PAGE = 4;

export enum LearnDataTag {
  GET_CAROUSELS_ACTION = 'get-carousels-action',
}

export const MOSTLY_VIEWED_CAROUSEL_TYPE = 'mostlyViewedInYourArea';
export const BASED_ON_YOUR_INTERESTS = 'basedOnYourInterests';
